export const ADD_SUCCESS = 'Новое пуш-уведомление добавлено';
export const ADD_ERROR = 'Не удалось добавить пуш-уведомление';
